document.addEventListener("DOMContentLoaded", () => {
  //add-to-cart
  const addToCartButtons = document.querySelectorAll(".red-btn");
  if (addToCartButtons.length > 0) {
    addToCartButtons.forEach((button) => {
      button.addEventListener("click", () => {
        const variantId = button.getAttribute("data-variant-id");

        fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ id: variantId, quantity: 1 }),
        })
          .then((response) => response.json())
          .then((data) => {
            console.log("Item added to cart:", data);

            updateCartCount();
          })
          .catch((error) => {
            console.error("Error adding item to cart:", error);
            alert("Failed to add item to cart.");
          });
      });
    });
  }
});

function updateCartCount() {
  fetch("/cart.js")
    .then((response) => response.json())
    .then((cart) => {
      // The below item selected is the html name of the bubble that represents inventory in the cart
      const cartCountElement = document.querySelector(".cart-count-bubble");
      if (cartCountElement) {
        console.log("cart found");
        cartCountElement.textContent = cart.item_count;
      }
    })
    .catch((error) => console.error("Error fetching cart data:", error));
}
